<template>
  <app-layout class="verify-mobile-template">
    <Modal
        :footer-hide="true"
        v-model="showPolice"
        @on-cancel="showPolice = false"
        class-name="vertical-center-modal">
        <h2 align="center">Account Exist</h2>
        <p align="center" style="font-size:15px">Your number <a>{{tempNumber}}</a> has already been <br/>used to register for a Sharpen App.</p>
        <p align="center" style="margin-top:10px">
          <small>(Sharpen School, Sharpen Family, SharpenUp College, <br/>Sharpen Up School or Sharpen Pro)</small></p>
        <label v-if="isResetPassword" style="margin-top:20px;display:block">
          <span style="font-size:13px">Change password</span>
          <Input id="pwd" @on-enter="signin" type="password" v-model="rpwd" placeholder="New password" style="margin-bottom:5px"/>
          <Input id="rpwd" @on-enter="signin" type="password" v-model="npwd" placeholder="Confirm new password"/>
        </label>
        <label v-else style="margin-top:20px;display:block">
          <span style="font-size:13px">Enter password</span>
          <Input @on-enter="signin" type="password" v-model="pwd" placeholder="Enter your password"/>
        </label>
        <div style="margin-top:10px">
          <span style="float:right">
            <Button type="text" @click="isResetPassword = !isResetPassword">
              {{(isResetPassword) ? "Remember password?":"Reset password?"}}
            </Button>
          </span>
          <Button type="primary" @click="signin" :loading="isLoggingIn" :disabled="isLoggingIn">Proceed</Button>
        </div>
    </Modal>

    <div style="padding:20px">
      <Row type="flex" :gutter="20" v-if="!vCode">
        <i-col span="24" style="margin-bottom:10px">
          <p align="center" style="font-size:18px;padding:5px 0">First, let's verify if you're<br/> a human.</p>
          <tel-input-lg v-model="mobile" @onTelInput="onTelInput" ref="telInput"></tel-input-lg></i-col>
        <i-col span="24" style="margin-bottom:10px">
          <Button v-if="!isStep" long size="large" type="primary" :loading="isGeneratingCode" :disabled="isGeneratingCode || isDisableSubmit" @click="onGenerateCode()">Submit</Button>
          <div v-else>
            <Button  style="float: right" :disabled="!tempNumber" type="primary" @click="onGenerateCode()">Next</Button>
            <Button @click="goBack()" type="text" class="btn-text" style="float:right;margin-right:10px;padding:6px 15px;color:#495060">
              Go Back
            </Button>
          </div>
        </i-col>
      </Row>
      <Row type="flex" :gutter="20" v-else>
        <i-col span="24" style="margin-bottom:10px">
          <p align="center" style="font-size:18px;padding:5px 0">
            <!-- <a style="float:right" @click="onGenerateCode()">Resend Code</a> -->
            We have sent you an access code via SMS for verification.
          </p>
          <!-- <i-input class="code-input" size="large" :maxlength="4" v-model="code" placeholder="Enter Code"></i-input> -->
          <div class="code-input ivu-input-wrapper ivu-input-wrapper-large ivu-input-type">
            <Input @on-enter="verify()" style="font-size:20px" size="large" type="number" v-model="code" :spellcheck="false" placeholder="Enter Code" :maxlength="4" />
          </div></i-col>
        <i-col span="24" style="margin-bottom:10px">
          <Button long size="large" type="primary" @click="verify()">Verify</Button>

        </i-col>

      </Row>
      <Row type="flex" :gutter="20">
          <i-col :span="24">
            <div class="signup" style="padding:10px 20px 10px">
              <p align="center" v-if="vCode"><i style="font-size:12px">{{tempNumber}}</i><br/><a @click="onReset()">Change Number</a> or <a @click="onGenerateCode()">Resend Code</a></p><br/>
              <p align="center">Already have an account? <router-link :to="'/'+$route.params.brandSlug+'/login?type=signin'">Login</router-link></p>
              <p align="center">Continue as <router-link :to="'/'+$route.params.brandSlug+'/'">Guest</router-link></p>
            </div>
        </i-col>
        <i-col v-if="brandInfo.enable_saml == 1 && brandInfo.saml" :span="24">
          <div class="signup" style="border-top: 1px solid #e8eaec; padding-top:20px">
            <p align="center"><Button id="saml-btn" type="primary" @click="redirectSSO" long>Login with {{brandInfo.saml.name}}</Button></p>
          </div>
        </i-col>
      </Row>
    </div>
  </app-layout>
</template>

<script>
import { mapGetters } from "vuex";
import { TelInputLg } from '@/helpers/tel-input';
import VueCookie from 'vue-cookie'
import store from '@/store'
import _ from "lodash";
import {Message} from 'iview'
import allCountries from '@/helpers/tel-input/assets/all-countries';
import { parsePhoneNumberFromString } from 'libphonenumber-js';
import Axios from "axios";

export default {
  mounted() {
    // if( this.$store.state.user.info && this.$store.state.user.info.user_type !== 'guest') {
    //   this.$router.replace('/home')
    //   return;
    // }
    const no = VueCookie.get('PRESCRIPTION_MOBILE')
    if( typeof no != null && no ) {
      console.log(typeof no)
      this.$refs.telInput.mobile_number  = no
      this.tempNumber = no

      var noMeta = parsePhoneNumberFromString(this.$store.state.base.VCodeMobile)
      var cc = "+" + noMeta.countryCallingCode
      var newNo = no.replace(cc, '')
      
      // this.$refs.telInput.setNumber(this.$refs.telInput.findCountry(noMeta.country), newNo)
      // this.tempNumber = newNo

      this.$refs.telInput.mobile_number  = newNo
      this.$refs.telInput.activeCountry = allCountries.find(country => country.iso2 === noMeta.country)

      this.tempNumber = newNo
      this.mobile = newNo
      this.isValidMobileNumber = this.$refs.telInput.state

    }
    var el = document.getElementById('saml-btn');
    if(el){
      window.addEventListener("message", this.returnSSO, false);
    }

    this.onReset();
  },
  data() {
    return {
      allCountries,
      code: null,
      mobile: null,
      isResetPassword: false,
      isLoggingIn: false,
      isValidMobileNumber: false,
      pwd: null,
      rpwd: null,
      showPolice: false,
      isGeneratingCode: false,
      npwd: null,
      verificationData: {
        exists: false
      },
      dialog: null
    }
  },
  computed: {
    ...mapGetters("user", ["brandInfo"]),
    isDisableSubmit() {
      if( !this.isValidMobileNumber ) return true;
      return false;
    },
    brand() {
      return this.$store.state.user.brand
    },
    isStep() {
      return this.$route.query.step
    },
    tempNumber: {
      get() {
        return this.$store.state.base.VCodeMobile
      },
      set(v) {
        store.commit('base/setVCodeMobile', v)
      }
    },
    vCode: {
      get() {
        return this.$store.state.base.vCode
      },
      set(v) {
        this.$store.commit('base/setVCode', v)
      }
    }
  },
  components: {
    TelInputLg
  },
  methods: {
    redirectSSO() {
      this.dialog = window.open(
        this.brandInfo.saml.login_url,
        '_blank',
        'width=340,height=600'
      );
    },
    returnSSO(e) {
      if (e && this.dialog !== null) {
        localStorage.removeItem(Cons[0].PATHS.NAME + Cons[0].PATHS.BRAND + "COOKIE");
        // clean up temp
        VueCookie.delete(
          `${Cons[0].PATHS.NAME}${Cons[0].PATHS.BRAND}VISITED_COURSE`
        );
        VueCookie.delete(
          `${Cons[0].PATHS.NAME}${Cons[0].PATHS.BRAND}VISITED_ARTICLE`
        );
        let date = new Date(e.data.token.expires_at);
        var seconds = date.getTime() / 1000; //1440516958

        var ndata = {
          token_type: "Bearer",
          expires_in: seconds,
          access_token: e.data.accessToken
        }

        localStorage.setItem(
          Cons[0].PATHS.NAME + Cons[0].PATHS.BRAND + "COOKIE",
          JSON.stringify(ndata));
        Axios.defaults.headers.common["Authorization"] = null;
        Axios.defaults.headers.common["Authorization"] =
          "Bearer " + e.data.accessToken;
        this.$store.dispatch("user/getUserInfo", null, { root: 1 });
        this.dialog.close();
        console.log('onboarding')
        setTimeout(() => {
          this.$router.replace({ path: '/onboarding' });
        }, 2000);
      }
    },
    goBack() {
      window.history.back();
    },
    onGenerateCode() {
      if (this.tempNumber && this.isValidMobileNumber && !this.tempNumber.includes('+')) {
        this.tempNumber = '+' + this.$refs.telInput.activeCountry.dialCode + this.tempNumber
      }

      if( !this.tempNumber ) {
        Message.warning("You've entered an invalid mobile number!")
        return false;
      }
      else {
        this.mobile = this.tempNumber
      }

      var vcode = Math.floor(1000 + Math.random() * 9000);
      if(this.mobile)  {
        this.isGeneratingCode = true;
        this.$store.dispatch("base/getCode", { 
          text: vcode + ' heres your verification code for '+this.brand.display_name, 
          mobile: this.tempNumber, vcode })
          .then( result => {
            console.log(result.data)
            VueCookie.set("verificationData", JSON.stringify(result.data))
            let _self = this;
            this.$vlf.createInstance({
              storeName: 'humanity'
            }).then((v) => {
              v.setItem('code', result.code)
              v.setItem('mobile', this.tempNumber)
              _self.isGeneratingCode = false;
              store.commit('base/setVCode', result.code)
              store.commit('base/setVCodeMobile', this.tempNumber)

              Message.success("Verification code sent.");      
            },
            error => {
              Message.error("Invalid mobile number.");
              // Message.error(error); 
              _self.isGeneratingCode = false;
            })
          })
          .catch( err => {
            Message.error("Something went wrong!")
            console.log(err)
          });
      }
    },
    onReset() {
      let _self = this;
      this.$vlf.createInstance({
        storeName: 'humanity'
      }).then((v) => {
        v.removeItem('code')
        v.removeItem('mobile')
        v.setItem('isVerified');
        
        _self.code = null;
        
        setTimeout( () => {
          this.tempNumber = _self.mobile ;
        })
        
        store.commit('base/setVCode', null)
        store.commit('base/setVCodeMobile', null)
        store.commit('base/setVCodeVerified', false)
      })
    },
    signin() {
      if ( this.isResetPassword ) {
        if (
          _.isEmpty(this.npwd) ||
          _.isEmpty(this.rpwd)
        ) {
          this.$store.commit("showNotice", {
            type: "warning",
            title: "Missing",
            desc: "Missing new password"
          });
          return false;
        }

        if (
          this.npwd !== this.rpwd
        ) {
          this.$store.commit("showNotice", {
            type: "warning",
            title: "Missing",
            desc: "Password dont match"
          });
          return false;
        }

        let dd = VueCookie.get("verificationData");
        let vData = JSON.parse(dd);

        this.isLoggingIn = true
        this.$store.dispatch("user/resetPassword", {
          user_id: vData.user_id,
          key: vData.key,
          new_password: this.npwd
        })
          .then( res => {
            this.authenticateUser();
          })
          .catch( err => {
            this.isLoggingIn = false
          })
        return false;
      } 

      this.authenticateUser();
    },
    authenticateUser() {
      if ( !this.isResetPassword ) {
        if (
          _.isEmpty(this.pwd) ||
          _.isEmpty(this.tempNumber)
        ) {
          this.$store.commit("showNotice", {
            type: "warning",
            title: "Missing",
            desc: "Missing mobile & password."
          });
          return false;
        }
      }

      grecaptcha.ready(() => {
        grecaptcha
          .execute(process.env.VUE_APP_CAPTCHA_KEY, {
            action: "submit",
          })
          .then((token) => {
            this.isLoggingIn = true;
            this.$store
              .dispatch("base/authenticate", {
                response: {
                  username: this.tempNumber,
                  password: this.isResetPassword ? this.npwd : this.pwd,
                  message:
                    "You have entered wrong password. Try again or reset password.",
                  token,
                },
              })
              .then((res) => {
                VueCookie.delete("verificationData");
                this.$vlf
                  .createInstance({
                    storeName: "systemAlert",
                  })
                  .then((v) => {
                    v.setItem("shareableActivity", {});
                    v.setItem("showAlert", true);
                  });
                this.isLoggingIn = false;
              })
              .catch((err) => {
                this.isLoggingIn = false;
              });
          });
      });
    },
    verify() {
      let dd = VueCookie.get("verificationData");
      let vData = JSON.parse(dd);
      if( vData.exists ) {
        this.showPolice = true
        return false;
      }

      if ( parseInt(this.code) === this.vCode ) {
        this.$vlf.createInstance({
          storeName: 'humanity'
        }).then( s => {
          s.setItem('isVerified', true);
          store.commit('base/setVCodeVerified', true)
          // store.commit('base/redirectToRegister')
          this.$router.replace(`/${this.$route.params.brandSlug}/login?type=signup&method=mobile`)
        })
      } else {
        this.$vlf.createInstance({
          storeName: 'humanity'
        }).then( s => {
          s.setItem('isVerified', false);
          store.commit('base/setVCodeVerified', false)
        })

        this.$Message({
          closable: true,
          title: { content:'Oops!' },
          icon: 'checkmark',
          message: { content: 'Invalid verification code, please check your verification code.!' },
          buttons: [
            { label: 'Ok', type: 'success', hideAfter:true, action: ()=> {} }
          ]
        });
      }
    },
    onTelInput(res) {
      console.log(res)
      this.isValidMobileNumber = res.isValid
      this.tempNumber = (res.isValid) ? res.number: null;

      if(res.isValid) 
        this.mobile = res.number;
    }
  }
}
</script>

<style>

</style>
